import { RateType } from '@m/constants/Rate';
import { DurationRate, FlatRate, RateBaseV2, TabularRateBase } from '@m/types/api';

export function isDurationRate(rate?: RateBaseV2 | null): rate is DurationRate {
  return rate?.type?.name === RateType.Duration;
}

export function isFlatRate(rate?: RateBaseV2 | null): rate is FlatRate {
  return rate?.type?.name === RateType.Flat;
}

export function isTabularRate(rate?: RateBaseV2 | null): rate is TabularRateBase {
  return rate?.type?.name === RateType.Tabular;
}
